function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.01275 0.15918L9.48185 6.03558L9.48535 6.05308C9.61378 6.6952 9.54979 7.38831 9.30095 8.01698L8.62801 9.86756C9.45853 11.207 10.4166 12.4561 11.5802 13.6198C12.6965 14.7361 13.9355 15.7275 15.2581 16.5561L17.2829 15.6702C17.9465 15.3439 18.6588 15.2895 19.3341 15.4123L19.3508 15.4153L24.8139 16.6673L23.973 24.8357L23.2615 24.7992C17.2298 24.4899 11.5534 22.0143 7.26959 17.7305L7.26635 17.7272C3.08806 13.4974 0.612277 7.92601 0.251304 1.99574L0.209473 1.3085L8.01275 0.15918ZM1.80044 2.59035C2.28147 7.90173 4.57249 12.8649 8.33187 16.6715C12.1796 20.5184 17.2271 22.8128 22.6279 23.2539L23.1859 17.8331L19.0501 16.8853C18.6378 16.8131 18.2624 16.8575 17.9353 17.021L17.9181 17.0296L15.1459 18.2424L14.814 18.0433C13.2599 17.1108 11.8116 15.9725 10.5196 14.6805C9.17066 13.3316 8.08402 11.8814 7.1568 10.336L6.97297 10.0297L7.89914 7.48268L7.90356 7.47163C8.04864 7.10892 8.0842 6.71319 8.0176 6.36321L6.88708 1.84116L1.80044 2.59035Z",
  fill: "#2F7067"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.bf3bd9ac.svg";
export { ForwardRef as ReactComponent };